export const WORKSPACE_PREVIEW_MASONRY_SIZES =
  'auto, (min-width: 80rem) 25vw, 33vw';
export const WORKSPACE_PREVIEW_SINGLE_SIZES =
  'auto, (min-width: 64rem) 40rem, 100vw';
export const WORKSPACE_PREVIEW_IMAGE_VARIANT = 'compact' as const;
export const WORKSPACE_PREVIEW_INITIAL_COUNT = 8;
export const WORKSPACE_PREVIEW_BATCH_SIZE = 12;

export function resolveWorkspacePreviewImageSizes(imageCount: number) {
  return imageCount === 1
    ? WORKSPACE_PREVIEW_SINGLE_SIZES
    : WORKSPACE_PREVIEW_MASONRY_SIZES;
}
